export default "__VITE_ASSET__CyIMRJf3__"